<template>
  <div>
    <div v-if="!ads.length">
      <b-alert show variant="warning">
        {{emptyMessage}}
      </b-alert>
    </div>
    <table class="table table-striped" v-if="ads.length">
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Shown</th>
          <th>Date Added</th>
          <th>Starts/Expires</th>
          <th class="action-single"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in ads" :key="item._id">
          <td>
            <i class="fa fa-eye mr-2" v-if="item.enabled===true"></i>
            <i class="fa fa-eye-slash mr-2" v-if="item.enabled===false || item.enabled===undefined"></i>
            <router-link :to="{name: 'Update Ad', params: {id: item._id}}">{{item.name}}</router-link>
          </td>
          <td class="text-transform:capitalize">{{item.type}}</td>
          <td>{{shown(item)}}</td>
          <td>
            {{item.dateAdded | formatDate}}
          </td>
          <td>
            <StartsExpires :item="item"></StartsExpires>
          </td>
          <td><button class="btn btn-sm btn-danger" @click="deleteItem(item)"><i class="fa fa-remove"></i> Delete</button></td>
        </tr>
      </tbody>
    </table>
    <b-modal title="Confirm Delete" class="modal-danger" v-model="deleteModal" @ok="confirmDelete()" ok-variant="danger">
      <div><b>Are you sure you want to delete this ad?</b></div>
      <div>{{selectedItem.name}}</div>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import common from './../../mixins/common'
import StartsExpires from '@/views/common/StartsExpires'

export default {
  name: 'adlist',
  data () {
    return {
      selectedItem: {},
      deleteModal: false
    }
  },
  components: {
    StartsExpires
  },
  props: ['ads','emptyMessage'],
  mixins: [common],
  methods: {
    deleteItem: function (selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function () {
      this.deleteModal = false;
      let scope = this;
      axios.delete(process.env.VUE_APP_API + '/ad/' + scope.selectedItem._id, {
        headers: {
          Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
          }
        })
          .then(function (response) {            
            scope.$emit('getItems');
          })
          .catch(function (error) {
            console.log(error);
          });
    }
  }
}
</script>
